import { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import { fetchCategories, fetchCategoryById, fetchGreetingOccasionImagesByCategoryId } from "./actions";
import { GreetingOccasionCategoryViewModel } from "../../../viewModels";
import Select from "../../../components/select";
import { GreetingOccasionSubcategory } from "../../../models";
import GreetingOccasionImage from "../../../models/GreetingOccasionImage";
import GreetingOccasionImages from "./ui/greeting-occasion-images";
import { PaginationResult } from "../../../lib/definitions";
import Pagination from "../../../components/pagination";
import GreetingOccasionImagesSkeleton from "./skeletons/greeting-occasion-images-skeleton";
import UploadImages from "./ui/upload-images";
import useOccasionCollections from "../../../hooks/useOccasionCollections";

export default function GreetingOccasionsImagesPage() {
    const [categories, setCategories] = useState<GreetingOccasionCategoryViewModel[]>([]);
    const [selectedCategory, setSelectedCategory] = useState<GreetingOccasionCategoryViewModel | null>(null);
    const [selectedSubcategory, setSelectedSubcategory] = useState<GreetingOccasionSubcategory | null>(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const {occasionCollections, loading: loadingOccasionCollections} =useOccasionCollections();
    const [images, setImages] = useState<PaginationResult<GreetingOccasionImage>>({
      items: [],
      page: page,
      pageSize: pageSize,
      totalCount: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      totalPages: 0,
    });
    useEffect(() => {
        fetchCategories().then(setCategories) ;
    }, []);
    useEffect(() => {
        getImages();
    }, [ selectedSubcategory,page,pageSize]);
    const getImages=async()=>{
      if(selectedSubcategory) {
        setLoading(true);
        const data = await fetchGreetingOccasionImagesByCategoryId(selectedSubcategory.id!,page,pageSize);
        setImages(data);
        setLoading(false);
    }
    }
    const handleCategoryChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const category = await fetchCategoryById(parseInt(e.target.value));
        reset();
        setSelectedCategory(category);
        setSelectedSubcategory(null);
    }
    const handleSubcategoryChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const subcategory = selectedCategory?.greetingOccasionSubcategories.find((item) => item.id === parseInt(e.target.value));
        reset();
        if(subcategory)
        setSelectedSubcategory(subcategory);
        else{
        setSelectedSubcategory(null);
    }}
    const handlePageSizeChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        setPageSize(parseInt(e.target.value));
        reset();
    }
    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    }
    const reset=()=>{
      setPage(1);
      setImages({
        items: [],
        page: 1,
        pageSize: pageSize,
        totalCount: 0,
        hasNextPage: false,
        hasPreviousPage: false,
        totalPages: 0,
      })
    }
    console.log({page});
    return <div className="w-full">
           <Breadcrumbs
                        breadcrumbs={[
                          { label: "Greeting Occasion Images", href: "/admin/greeting-occasions-images" },                      
                        ]}
                      />         
                      <div className="flex  gap-4  max-w-xl">
                        
                        <Select className="flex-grow" onChange={handleCategoryChange} placeholder="Select category" items={categories.map((item) => ({
                          id: item.id,
                          name: item.name,
                        }))} />

                        <Select className="flex-grow" onChange={handleSubcategoryChange} placeholder="Select subcategory" 
                        value={selectedSubcategory?.id||""}
                        items={selectedCategory?.greetingOccasionSubcategories.map((item) => ({
                          id: item.id,
                          name: item.name,
                        }))||[]} />
                        <Select className="flex-grow" onChange={handlePageSizeChange} 
                        placeholder="Page size" 
                        value={pageSize.toString()}
                        items={[{id: 10, name: "10"},{id: 20, name: "20"},{id: 30, name: "30"},{id: 40, name: "40"},{id: 50, name: "50"}]} />
                       
                      </div>
                      <UploadImages categoryId={selectedSubcategory?.id||0} onUploaded={getImages} key={selectedSubcategory?.id} />
                      {loading ? <GreetingOccasionImagesSkeleton /> : <GreetingOccasionImages images={images.items||[]} occasionCollections={occasionCollections} />}                      
                      <div className="mt-5 flex w-full justify-center">
                        <Pagination totalPages={images.totalPages} currentPage={page} onPageChange={handlePageChange} />
                      </div>
       </div>
}